import { ca } from '@cian/analytics';

export function trackQuickLinkMoreButtonClick(): void {
  ca('eventSite', {
    action: 'click_sopr',
    category: 'seo_block_top',
    label: 'more_link',
    name: 'oldevent',
  });
}

export function trackQuickLinkClick<T extends { url: string }>(quickLink: T): void {
  ca('eventSite', {
    action: 'click_sopr',
    category: 'seo_block_top',
    label: quickLink.url,
    name: 'oldevent',
  });
}
